import mongoose from "mongoose";

import { Class, Semester } from "../models";

export async function isSemesterLockedForClass(
  classId: mongoose.Types.ObjectId | string,
): Promise<boolean> {
  const classItem = await Class.findById(classId).select("semesterId").lean();
  if (!classItem?.semesterId) {
    return false;
  }

  const semester = await Semester.findById(classItem.semesterId)
    .select("endDate status")
    .lean();
  if (!semester) {
    return false;
  }

  if (semester.status === "completed") {
    return true;
  }

  const lockDate = new Date(semester.endDate);
  lockDate.setUTCHours(23, 59, 59, 999);
  return Date.now() > lockDate.getTime();
}
